var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useFragment } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { Form, Formik } from 'formik';
import { useCreateFileSystemAcls } from 'app/domains/filesystem';
import { accessManagementSchema } from 'app/domains/filesystem/components/AccessManagement/accessManagementSchema';
import { calculateACLChanges } from 'app/domains/filesystem/components/AccessManagement/calculateACLChanges';
import { DocumentAccessFormFragmentDoc } from './DocumentAccessForm.gql';
export function DocumentAccessForm(props) {
    const { children, from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: DocumentAccessFormFragmentDoc,
    });
    const { addToast } = useToast();
    const { createFileSystemAcls } = useCreateFileSystemAcls({ entryId: data.id });
    const initialValues = {
        userAcls: complete ? data.acls : [],
        teamAcls: complete ? data.teamAcls : [],
    };
    if (!complete) {
        return null;
    }
    const handleOnSave = (values) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield createFileSystemAcls({
                userAcls: calculateACLChanges(initialValues.userAcls, values.userAcls),
                teamAcls: calculateACLChanges(initialValues.teamAcls, values.teamAcls),
            });
            addToast({
                title: t({
                    message: 'Access for document updated',
                    comment: 'add access to folder or document toast success message',
                }),
                appearance: 'success',
            });
        }
        catch (_a) {
            addToast({
                title: t({
                    message: 'Failed to update access for document',
                    comment: 'add access to folder or document toast error message',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<Formik enableReinitialize // NOTE: This is important so the form re-initializes when the data changes.
     initialTouched={false} initialValues={initialValues} onSubmit={handleOnSave} validationSchema={accessManagementSchema}>
      <Form>{children}</Form>
    </Formik>);
}
